import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import ReactWhatsapp from 'react-whatsapp';
import { BASE_URLS } from '../config/globalConfig';
import ContactForm from './ContactForm';
import SuccessModal from './SuccessModal';
import './FixedContactIcons.css';

const FixedContactIcons = () => {
    const location = useLocation();
    
    // Hide contact icons on LiveClass page
    const isLiveClassPage = location.pathname.includes('/live-class/');
    const [isVisible] = useState(!isLiveClassPage);
    const [showContactModal, setShowContactModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const handlePhoneClick = () => {
        window.open(`tel:${BASE_URLS.CONTACT.PHONE}`, '_self');
    };

    const handleEmailClick = () => {
        window.open(`mailto:${BASE_URLS.CONTACT.EMAIL}`, '_self');
    };

    const handleContactFormHover = () => {
        setShowContactModal(true);
    };

    const handleContactFormLeave = () => {
        setShowContactModal(false);
    };

    const handleContactFormClick = () => {
        setShowContactModal(true);
    };

    const handleContactFormSuccess = () => {
        setShowContactModal(false);
        setShowSuccessModal(true);
    };

    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
    };


    return (
        <>
            {isVisible && (
                <div className="fixed-contact-icons">
                    {/* WhatsApp Icon */}
                    <ReactWhatsapp
                        number={BASE_URLS.CONTACT.WHATSAPP}
                        message="Hi! I'd like to know more about your courses."
                        element="button"
                        className="contact-icon whatsapp-icon"
                        title="Chat on WhatsApp"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24">
                            <defs>
                                <linearGradient id="whatsappGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="#efc285" />
                                    <stop offset="25%" stopColor="#f5d4a5" />
                                    <stop offset="50%" stopColor="#efc285" />
                                    <stop offset="75%" stopColor="#e6b875" />
                                    <stop offset="100%" stopColor="#efc285" />
                                </linearGradient>
                            </defs>
                            <path fill="url(#whatsappGradient)" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                        </svg>
                        <span>WhatsApp</span>
                    </ReactWhatsapp>
                    <div className="icon-border"></div>

                    {/* Phone Icon */}
                    <button
                        className="contact-icon phone-icon"
                        onClick={handlePhoneClick}
                        title="Call us"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <defs>
                                <linearGradient id="phoneGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="#efc285" />
                                    <stop offset="25%" stopColor="#f5d4a5" />
                                    <stop offset="50%" stopColor="#efc285" />
                                    <stop offset="75%" stopColor="#e6b875" />
                                    <stop offset="100%" stopColor="#efc285" />
                                </linearGradient>
                            </defs>
                            <path stroke="url(#phoneGradient)" strokeWidth="2" d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                        </svg>
                        <span>Contact</span>
                    </button>
                    <div className="icon-border"></div>

                    {/* Email Icon */}
                    <button
                        className="contact-icon email-icon"
                        onClick={handleEmailClick}
                        title="Send us an email"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <defs>
                                <linearGradient id="emailGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="#efc285" />
                                    <stop offset="25%" stopColor="#f5d4a5" />
                                    <stop offset="50%" stopColor="#efc285" />
                                    <stop offset="75%" stopColor="#e6b875" />
                                    <stop offset="100%" stopColor="#efc285" />
                                </linearGradient>
                            </defs>
                            <path stroke="url(#emailGradient)" strokeWidth="2" d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                            <polyline stroke="url(#emailGradient)" strokeWidth="2" points="22,6 12,13 2,6"/>
                        </svg>
                        <span>Email</span>
                    </button>
                    <div className="icon-border"></div>

                    {/* Contact Form Icon */}
                    <button
                        className="contact-icon contact-form-icon"
                        onMouseEnter={handleContactFormHover}
                        onMouseLeave={handleContactFormLeave}
                        onClick={handleContactFormClick}
                        title="Fill out contact form"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <defs>
                                <linearGradient id="formGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" stopColor="#efc285" />
                                    <stop offset="25%" stopColor="#f5d4a5" />
                                    <stop offset="50%" stopColor="#efc285" />
                                    <stop offset="75%" stopColor="#e6b875" />
                                    <stop offset="100%" stopColor="#efc285" />
                                </linearGradient>
                            </defs>
                            <path stroke="url(#formGradient)" strokeWidth="2" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                            <polyline stroke="url(#formGradient)" strokeWidth="2" points="14,2 14,8 20,8"/>
                            <line stroke="url(#formGradient)" strokeWidth="2" x1="16" y1="13" x2="8" y2="13"/>
                            <line stroke="url(#formGradient)" strokeWidth="2" x1="16" y1="17" x2="8" y2="17"/>
                            <polyline stroke="url(#formGradient)" strokeWidth="2" points="10,9 9,9 8,9"/>
                        </svg>
                        <span>Contact</span>
                    </button>
                </div>
            )}

            {/* Contact Form Modal */}
            {showContactModal && (
                <div 
                    className="contact-form-modal-overlay" 
                    onClick={(e) => e.target === e.currentTarget && setShowContactModal(false)}
                    onMouseEnter={() => setShowContactModal(true)}
                    onMouseLeave={() => setShowContactModal(false)}
                >
                    <div className="contact-form-modal-container">
                        <div className="contact-form-modal-header">
                            <h2 className="contact-form-modal-title">Contact Us</h2>
                            <button 
                                className="contact-form-modal-close" 
                                onClick={() => setShowContactModal(false)}
                                aria-label="Close modal"
                            >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <line x1="18" y1="6" x2="6" y2="18"/>
                                    <line x1="6" y1="6" x2="18" y2="18"/>
                                </svg>
                            </button>
                        </div>
                        <div className="contact-form-modal-body">
                            <ContactForm onSuccess={handleContactFormSuccess} />
                        </div>
                    </div>
                </div>
            )}

            {/* Success Modal */}
            <SuccessModal
                isOpen={showSuccessModal}
                onClose={handleCloseSuccessModal}
                title="Thank You!"
                message="We'll get back to you as soon as possible."
            />
        </>
    );
};

export default FixedContactIcons;
